import React, { useEffect, useState } from "react";
import styles from "./MemoryLab.module.css";
import { getUser } from "./utils/storage"; 

import { memoryIntroText } from "./content/memoryIntroText";
import { memoryScienceText } from "./content/memoryScienceText";
import { memoryHowItWorks } from "./content/memoryHowItWorks";
import { memoryFinalText } from "./content/memoryFinalText";

import UserProfile from "./components/UserProfile/UserProfile";

// GAMES
import NumberSequence from "./games/NumberSequence/NumberSequence";
import VisualPattern from "./games/VisualPattern/VisualPattern";
import DelayMemory from "./games/DelayMemory/DelayMemory";

const MemoryLab = () => {
  const [game, setGame] = useState(null);
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    document.title = "Memory Lab | Treinamento de Memória - Fohattech";
  }, []);

  const goHome = () => setGame(null);

  // 🔥 TEXTO DINÂMICO
  function getShareText() {
    const user = getUser();

    const sequence = user.scores?.sequence || 0;
    const visual = user.scores?.visual || 0;
    const delay = user.scores?.delay || 0;

    const max = Math.max(sequence, visual, delay);

    if (max === 0) {
      return "Testei minha memória nesse desafio… consegue se sair melhor? 🧠";
    }

    if (max === sequence) {
      return "Minha memória sequencial é dominante 🔢… consegue bater meu resultado? 🧠";
    }

    if (max === visual) {
      return "Minha memória visual é dominante 👁️… duvido você bater isso! 🧠";
    }

    return "Minha memória de retenção é absurda ⏱️… consegue superar? 🧠";
  }

  async function handleShare() {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Memory Lab - Teste sua Memória",
          text: getShareText(),
          url: window.location.href,
        });
      } else {
        fallbackShare();
      }
    } catch (error) {
      console.log("Compartilhamento cancelado ou não suportado");
    }
  }

  function fallbackShare() {
    const text = `${getShareText()} ${window.location.href}`;

    navigator.clipboard.writeText(text);

    setShowToast(true);

    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  }

  return (
    <div className={styles.container}>

      <h2 className={styles.title}>🧠 Memory Lab</h2>
      <p className={styles.subtitle}>
        Treine diferentes tipos de memória com desafios progressivos.
      </p>

      {/* 🔥 1 BLOCO PRINCIPAL */}
      <div className={styles.seoBox}>
        <h3>O que é o Memory Lab?</h3>
        {memoryIntroText}
      </div>

      {/* 🔥 2 BLOCO (mais direto) */}
      <div className={styles.seoBox}>
        <h3>Como funciona o treinamento?</h3>
        {memoryHowItWorks}
      </div>

      <UserProfile />

      {/* 🎮 ÁREA DE JOGOS */}
      {!game && (
        <div className={styles.gamesSection}>

          <div className={styles.gamesHeader}>
            <h3>🎮 Escolha seu desafio</h3>
            <p>
              Clique em um dos cards abaixo para iniciar o teste de memória.
              Cada desafio trabalha uma habilidade diferente do seu cérebro.
            </p>
          </div>

          <div className={styles.gameGrid}>

            <div
              className={`${styles.gameCard} ${styles.sequence}`}
              onClick={() => setGame("sequence")}
            >
              <h3>🔢</h3>
              <h2>Memória Sequencial</h2>
              <p>Números e padrões lógicos</p>
            </div>

            <div
              className={`${styles.gameCard} ${styles.visual}`}
              onClick={() => setGame("visual")}
            >
              <h3>👁️</h3>
              <h2>Memória Visual</h2>
              <p>Padrões visuais e percepção</p>
            </div>

            <div
              className={`${styles.gameCard} ${styles.delay}`}
              onClick={() => setGame("delay")}
            >
              <h3>⏱️</h3>
              <h2>Memória de Retenção</h2>
              <p>Lembrar após distração</p>
            </div>

          </div>
        </div>
      )}

      {/* 🎮 JOGOS */}
      {game && (
        <div className={styles.gameWrapper}>
          {game === "sequence" && <NumberSequence goHome={goHome} />}
          {game === "visual" && <VisualPattern goHome={goHome} />}
          {game === "delay" && <DelayMemory goHome={goHome} />}
        </div>
      )}

      <button onClick={handleShare} className={styles.buttonShare}>
        Compartilhe e desafie alguém! 🔗
      </button>

      {/* 🔥 TEXTO MOVIDO PRA BAIXO */}
      <div className={styles.seoBox}>
        <h3>Como funciona a memória humana?</h3>
        {memoryScienceText}
      </div>

      <div className={styles.finalBox}>
        <h3>Conclusão</h3>
        {memoryFinalText}
      </div>

      {showToast && (
        <div className={styles.toast}>
          🔗 Link copiado com sucesso!
        </div>
      )}

    </div>
  );
};

export default MemoryLab;